'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Overlay = require('../Overlay2');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _DataSelector = require('../../common/Class/DataSelector');

var _DataSelector2 = _interopRequireDefault(_DataSelector);

var _scale = require('./scale');

var _scale2 = _interopRequireDefault(_scale);

var _Helpers = require('../../common/Helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  modal: new _DataSelector2.default('data-size-guide-modal'),
  images: new _DataSelector2.default('data-img-src'),
  modalClose: new _DataSelector2.default('data-close-modal'),
  modalTrigger: new _DataSelector2.default('data-sg-trigger')
};
var dom = {};
var ACTIVE_CLASS = 'size-guide--is-active';

var cacheDom = function cacheDom() {
  dom.modal = document.querySelector(selectors.modal.bracketed());
  dom.modalClose = document.querySelector(selectors.modalClose.bracketed());
  dom.modalTrigger = document.querySelectorAll(selectors.modalTrigger.bracketed());
  dom.imagesMobile = [];
  dom.imagesDesktop = [];
  dom.imagesAll = [];

  if (dom.modal) {
    dom.imagesMobile = dom.modal.parentElement.querySelectorAll(selectors.images.valueContains('mobile-')) || [];
    dom.imagesDesktop = dom.modal.parentElement.querySelectorAll(selectors.images.valueContains('desktop-')) || [];
    dom.imagesAll = dom.modal.parentElement.querySelectorAll(selectors.images.valueContains('all-')) || [];
  }
};

var getWorkingImageSet = function getWorkingImageSet() {
  if (window.innerWidth > 992) {
    return [].concat((0, _toConsumableArray3.default)(dom.imagesDesktop), (0, _toConsumableArray3.default)(dom.imagesAll));
  }
  return [].concat((0, _toConsumableArray3.default)(dom.imagesMobile), (0, _toConsumableArray3.default)(dom.imagesAll));
};

var bindListeners = function bindListeners() {
  // dom.modalClose.addEventListener('click', SizeGuideModal.close.bind(document));
  $(document).on('click', '[data-close-modal]', SizeGuideModal.close);
  // dom.modalTrigger.forEach(el => el.addEventListener('click', SizeGuideModal.open.bind(self)));
  // dom.modal.addEventListener('click', overlayClickHandler);
  $(document).on('click', '[data-size-guide-modal]', overlayClickHandler);
  window.addEventListener('resize', loadImagesDebounced);

  $(document).on('click', '[data-sg-trigger]', function (event) {
    SizeGuideModal.open(event);
  });
};

var resetImages = function resetImages() {
  [].concat((0, _toConsumableArray3.default)(dom.imagesMobile), (0, _toConsumableArray3.default)(dom.imagesDesktop)).forEach(function (el) {
    el.src = null;
    el.style.backgroundImage = null;
  });
};

var loadImages = function loadImages() {
  resetImages();
  getWorkingImageSet().forEach(setImage);
};

/**
 *
 * @param {Event} param0
 */
var overlayClickHandler = function overlayClickHandler(_ref) {
  var target = _ref.target;

  if (target && target === dom.modal) {
    SizeGuideModal.close();
  }
};

var loadImagesDebounced = (0, _Helpers.debounce)(loadImages);

/**
 * @desc set background
 * @param {Element} el
 */
var setImage = function setImage(el) {
  var src = el.dataset[selectors.images.key()].replace(/^(?:mobile|desktop|all)\-/, '');

  if (!src) {
    return;
  }

  switch (el.tagName) {
    case 'IMG':
      el.src = src;
      break;
    default:
      el.style.backgroundImage = 'url(' + src + ')';
  }
};

/**
 * @listens click on data-sg-trigger
 */
var SizeGuideModal = {
  init: function init() {
    _Overlay2.default.init().on('disable', SizeGuideModal.close.bind(this));
    cacheDom();
    bindListeners();
    if (document.readyState === 'complete') {
      _scale2.default.init();
    } else {
      window.addEventListener('load', _scale2.default.init); // wait unitil d3 finished loading in.
    }
  },


  /**
   * @param {Event} [event]
   */
  open: function open(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    loadImages();
    (0, _Helpers.addClass)(dom.modal, ACTIVE_CLASS);
    _Overlay2.default.enable();
  },
  close: function close() {
    _Overlay2.default.disable();
    (0, _Helpers.removeClass)(dom.modal, ACTIVE_CLASS);
  }
};

window.SizeGuideModal = SizeGuideModal;
exports.default = SizeGuideModal;